import React, { useEffect, useState } from 'react';
import Modal from '../../components/Shell/Modal';
import useModal from '../../hooks/useModal';
import { ServerIcon, ServerStackIcon } from '@heroicons/react/24/outline';
import { TemplateReactSelect } from '../../components/Attributes/Attributes_old';

const MODAL_NAME = 'assetModal';

const AddAssetModalEntry = () => {
	const { open: options, setClose } = useModal(MODAL_NAME);
	const { setOpen } = useModal('assetModalForm');

	return (
		<>
			<Modal
				title={'Create a new asset'}
				open={!!options}
				onClose={() => {
					setClose({ onClose: options?.onClose });
				}}
				preventBackdropClose
				zIndex={40}
			>
				<div className="grid grid-cols-2 gap-x-4 gap-y-4">
					<div
						onClick={() => {
							setClose();
							setOpen();
						}}
						className="border border-gray-200 hover:border-gray-300 cursor-pointer rounded-lg text-xs h-36 flex justify-center items-center font-light text-gray-600 hover:text-gray-900 flex-col"
					>
						<ServerIcon className="w-6 h-6 text-gray-600 hover:text-gray-900 mb-3" />
						Single Asset
					</div>
					<div
						onClick={() => {}}
						className="border border-gray-200 hover:border-gray-300 cursor-pointer rounded-lg text-xs h-36 flex justify-center items-center font-light text-gray-600 hover:text-gray-900 flex-col"
					>
						<ServerStackIcon className="w-6 h-6 text-gray-600 hover:text-gray-900 mb-3" />
						Upload CSV
					</div>
					<div className="col-span-2">
						<div className="flex">
							<div className="flex-1">
								<TemplateReactSelect
									name={'or choose an asset to duplicate'}
									placeholder="Select an existing asset to duplicate"
									dataIndex={'assetId'}
									options={[]}
									value={null}
									onChange={(index, category) => {}}
									disabled={true}
								/>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default AddAssetModalEntry;
